<template>
  <div id="index">
    <el-container>
      <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
        <el-main>
          <nav-bar></nav-bar>
          <el-form
            ref="formselect"
            :model="formselect"
            label-width="130px"
            class="queryform_div"
          >
            <el-row :gutter="24">
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('title.productLine')">
                  <el-select
                    size="small"
                    v-model="formselect.value1"
                    filterable
                    collapse-tags
                    :placeholder="$t('desc.select')"
                    style="width: 100%"
                    @change="changeProductLine"
                  >
                    <el-option
                      v-for="item in productLineArr"
                      :key="item.bnDictCode"
                      :label="item.bnDictName"
                      :value="item.bnDictCode"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item :label="$t('desc.customer')">
                  <el-input
                    type="text"
                    placeholder=" "
                    v-model="formselect.customerName"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col :md="8" :xs="24" :sm="24">
                <el-form-item
                  :label="
                    $t('title.customerCenter') + ' / ' + $t('title.liaison')
                  "
                >
                  <template slot-scope="scope">
                    <el-cascader
                      collapse-tags
                      placeholder=""
                      size="small"
                      :props="{ multiple: true, checkStrictly: true }"
                      v-model="formselect.value2"
                      :options="centerOptionsShow"
                      style="width: 100%"
                    ></el-cascader>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :md="24" :xs="24" :sm="24">
                <el-form-item label=" ">
                  <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-search"
                    @click="getDataList"
                    >{{ $t("button.query") }}</el-button
                  >
                  <el-button size="small" @click="resetKeyword">{{
                    $t("button.reset")
                  }}</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <el-row
            class="clientRow"
            style="
              margin-left: -10px !important;
              margin-right: -10px !important;
            "
          >
            <el-col
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              v-for="item in clientList"
              :key="item.id"
            >
              <el-card
                class="box-card clientList"
                shadow="hover"
                style="margin-bottom: 20px"
                :key="item.id"
              >
                <div slot="header" class="clearfix">
                  <el-button type="text" @click="openClient(true, item)">
                    {{ item.customerName }}</el-button
                  >
                  <el-button
                    icon="el-icon-data-line"
                    :title="$t('title.viewMonitor')"
                    type="text"
                    style="float: right; margin-top: -2px; font-size: 20px"
                    @click="openMonitor(true, item)"
                  ></el-button>
                  <el-button
                    icon="el-icon-document"
                    :title="$t('RunningTIme.viewReport')"
                    type="text"
                    style="
                      float: right;
                      margin-top: -2px;
                      margin-right: 5px;
                      font-size: 20px;
                      color: #999;
                    "
                    @click="openReportDialog(item)"
                  ></el-button>
                </div>
                <el-row :gutter="24">
                  <el-col :span="24">
                    <span
                      >{{ $t("title.customerCode") }}:<strong>{{
                        item.customerCode
                      }}</strong></span
                    >
                  </el-col>
                  <el-col :span="24">
                    <span
                      >{{ $t("title.area") }}：<strong>{{
                        item.regionId
                      }}</strong></span
                    >
                  </el-col>
                  <el-col :span="24">
                    <span
                      >{{ $t("title.customerCenter") }}：<strong>{{
                        item.customerCenter
                      }}</strong></span
                    >
                  </el-col>
                  <el-col :span="24">
                    <span
                      >{{ $t("title.companyType") }}：<strong>{{
                        $t(companyTypeList[item.companyType])
                      }}</strong></span
                    >
                  </el-col>
                  <el-col :span="24">
                    <span>{{ $t("title.AirCompressorBindNumber") }}： </span
                    ><strong class="numcircle">{{
                      item.deviceBindCount
                    }}</strong>
                  </el-col>
                  <el-col :span="24">
                    <span>{{ $t("title.AirCompressorAlarmNumber") }}： </span
                    ><strong
                      class="numcircle"
                      :style="item.deviceWarnCount ? 'color:red' : ''"
                      >{{ item.deviceWarnCount }}</strong
                    >
                  </el-col>
                </el-row>
              </el-card>
            </el-col>
          </el-row>

          <el-pagination
            @size-change="handleSizeChange"
            background
            layout="prev, pager, next,sizes"
            :total="totalPage"
            @current-change="handleCurrentChange"
            :current-page="skipCount"
            :page-size="maxResultCount"
            :page-sizes="[10, 20, 50]"
          >
          </el-pagination>
        </el-main>
      </el-scrollbar>
    </el-container>
    <!-- 点击用户后的设备监控页卡片 -->
    <monitor-device-dialog
      :dialogClient="dialogClient"
      :title="dialogTitle"
      :deviceTable="deviceTableShow"
      :customerId="customerId"
      :activeLang="activeLang"
      @onSearchBtn="getDeviceTable"
      @dialogVisibleEvent="openClient"
      @openDevice="openMonitorListDevice"
      @changeCState="changeCState"
    >
    </monitor-device-dialog>
<!-- 客户名称右边的“查看监控”按钮弹出的弹窗 -->
    <monitor-dialog
      ref="monitorRef"
      :dialogClient="dialogMonitor"
      :title="dialogTitle"
      :gatherOption="gatherOptionShow"
      :monitorDataList="monitorDataList"
      :customer="hisCustomer"
      :activeLang="activeLang"
      :projectType = "projectType"
      @onSearchBtn="getDeviceTable"
      @dialogVisibleEvent="openMonitor"
      @showEcharts="getMonitorHistory"
    >
    </monitor-dialog>
    <!-- 单台设备的设备监控页 -->
    <monitor-deviceInfo-Dialog
      ref="deviceInfoRef"
      :dialogClient="dialogDevice"
      :title="deviceTitle"
      :DeviceInfo="DeviceInfo"
      :CustomerInfo="CustomerInfo"
      :gatherOption="ccnGatherOption"
      :ccnCodeList222="ccnCodeList222"
      :activeLang="activeLang"
      :isDingOrBian="isDingOrBian"
      :echartID="echartID"
      :echartIDHistory="echartIDHistory"
      :maintainList="maintainList"
      :IsShowSensitive="IsShowSensitive"
      :UseRateData="UseRateData"
      @getMonitorHistoryByGsn="getMonitorHistoryByGsn"
      @dialogVisibleEvent="openMonitorListDevice"
      @openCcnTable="openCcnTable"
      @getRealData="getRealData"
      @changeCode="changeCode"
      @openMaintain="openMaintainDialog"
      @openTripWarning="openTripWarningDialog"
    >
    </monitor-deviceInfo-Dialog>
    <monitor-ccn-table
      :dialogClient="dialogDeviceCCN"
      :title="tableTitle"
      :tableCCN="tableCCN"
      :tableType="tableType"
      @dialogVisibleEvent="openCcnTable"
    >
    </monitor-ccn-table>
    <monitor-maintain-dialog
      :dialogClient="dialogMaintain"
      :title="maintainTitle"
      :serviceform="serviceform"
      :tableService="tableService"
      @dialogVisibleEvent="openMaintainDialog"
    >
    </monitor-maintain-dialog>

    <monitor-TripWarning-Dialog
      :dialogClient="dialogTripWarning"
      title="告警监控"
      @dialogVisibleEvent="openTripWarningDialog"
    >
    </monitor-TripWarning-Dialog>

    <el-dialog
      :title="$t('RunningTIme.custReport')"
      :visible.sync="ReportDialog"
      :before-close="closeReportDialog"
      width="90%"
      top="5%"
      :modal-append-to-body="false"
    >
      <el-form
        ref="ReportFormselect"
        :model="ReportFormselect"
        label-width="100px"
        class="queryform_div"
      >
        <el-row :gutter="24">
          <el-col :md="8" :sm="12" :xs="24">
            <el-form-item :label="$t('RunningTIme.reportType')">
              <el-select v-model="ReportFormselect.queryString">
                <!-- <el-option :label="$t('desc.all')" value="all"></el-option> -->
                <el-option
                  :label="$t('menu.MisureReport_View')"
                  value="report3"
                ></el-option>
                <el-option
                  :label="$t('menu.CustomerReport_View')"
                  value="report4"
                ></el-option>
                <el-option :label="$t('menu.AssetReport_View')" value="report5">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="9" :sm="12" :xs="24">
            <el-form-item :label="$t('RunningTIme.reportDate')">
              <el-date-picker
                v-model="ReportFormselect.time"
                type="daterange"
                value-format="yyyy-MM-dd HH:mm:ss"
                align="right"
                unlink-panels
                :range-separator="$t('title.to')"
                :start-placeholder="$t('title.beginDate')"
                :end-placeholder="$t('title.endDate')"
                style="width: 100%"
                size="small"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :md="7" :sm="24" :xs="24" style="margin-top: 10px">
            <el-button type="primary" @click="getReportList()" size="small">
              {{ $t("button.query") }}
            </el-button>
            <el-button @click="resetReport" size="small">{{
              $t("button.reset")
            }}</el-button>
          </el-col>
        </el-row>
      </el-form>
      <template>
        <div class="tableDiv">
          <el-table
            :data="ReportData"
            stripe
            style="width: 100%"
            :empty-text="$t('desc.noData')"
          >
            <el-table-column
              type="index"
              :label="$t('title.serialNumber')"
              width="60px"
              fixed="left"
            >
            </el-table-column>
            <el-table-column
              prop="name"
              :label="$t('RunningTIme.Name')"
              min-width="120px"
            >
              <!-- <template slot-scope="scope">
                <label v-if="ReportFormselect.queryString !== 'report5'">{{
                  scope.row.name
                }}</label>
                <label v-else-if="ReportFormselect.queryString === 'report5'">{{
                  scope.row.name.replace('.xlsx','.pdf')
                }}</label>
              </template> -->
            </el-table-column>
            <el-table-column
              prop="fileType"
              :label="$t('RunningTIme.Type')"
              min-width="50px"
            >
              <!-- <template slot-scope="scope">
                <label v-if="ReportFormselect.queryString !== 'report5'">{{
                  scope.row.fileType
                }}</label>
                <label v-else-if="ReportFormselect.queryString === 'report5'">{{
                  'pdf'
                }}</label>
              </template> -->
            </el-table-column>
            <el-table-column
              prop="lastModified"
              :label="$t('RunningTIme.LastModify')"
              min-width="100px"
            >
            </el-table-column>
            <el-table-column
              v-if="isShowSize"
              prop="size"
              :label="$t('RunningTIme.Size')"
              min-width="40px"
            >
            </el-table-column>
            <el-table-column
              prop="storageClass"
              :label="$t('RunningTIme.StorageClass')"
              min-width="40px"
            >
            </el-table-column>
            <el-table-column :label="$t('title.operate')" width="80px">
              <template slot-scope="scope">
                <el-button
                  type="default"
                  icon="el-icon-download"
                  circle
                  size="mini"
                  :title="$t('RunningTIme.Download')"
                  @click="downLoadRunTImeFileFromS3(scope.row)"
                >
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>
    </el-dialog>

    <div
      id="pdfDom"
      style="margin-top: -99999999px; width: 1000px"
      class="pdfDiv"
    >
      <div class="pdfHeader">
        <h4>Industrial Technologies & Services</h4>
        <img src="~assets/img/IRlogo.png" />
        <span class="sub"
          >Origination Date: <strong>{{ PdfContent.reportDate }}</strong></span
        >
      </div>
      <div class="AssetDiv">
        <div class="block">
          <img src="~assets/img/icon_Shipped.png" />
          <div class="LeftB">
            <h4>{{ $t("desc.customerName") }}</h4>
            <span class="name">{{ PdfContent.customerName }}</span>
          </div>
        </div>
      </div>
      <div class="AssetDiv">
        <div class="block">
          <h4 class="subTitle">{{ $t("desc.alarmAbstract") }}</h4>
          <el-table
            :data="AlarmTable"
            stripe
            style="width: 100%"
            :empty-text="$t('desc.noData')"
          >
            <el-table-column
              :label="$t('desc.customerAssent')"
              min-width="60px"
              prop="dsn"
            >
            </el-table-column>
            <el-table-column
              :label="$t('desc.alarmAbstract')"
              min-width="100px"
              prop="alarmAbstract"
            >
            </el-table-column>
            <el-table-column
              :label="$t('desc.alarmTime')"
              min-width="60px"
              prop="alarmTime"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="AssetDiv">
        <div class="block">
          <h4 class="subTitle">{{ $t("desc.serviceRecord") }}</h4>

          <el-table
            :data="ServiceTable"
            stripe
            style="width: 100%"
            :empty-text="$t('desc.noData')"
          >
            <el-table-column
              :label="$t('desc.customerAssent')"
              min-width="60px"
              prop="dsn"
            >
            </el-table-column>
            <el-table-column
              :label="$t('desc.serviceRecord')"
              min-width="100px"
              prop="maintain"
            >
            </el-table-column>
            <el-table-column
              :label="$t('desc.estimatedServiceDate')"
              min-width="60px"
              prop="maintainTime"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div class="AssetDiv">
        <div class="block">
          <h4 class="subTitle">{{ $t("desc.tendency") }}</h4>
          <div
            class="echarts npPointer"
            style="height: 200px; margin-bottom: 20px"
            id="Line1"
          ></div>

          <div class="echarts npPointer" style="height: 200px" id="Line2"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getCustomerRegionTree,
  getAllCustomer,
  getCustomerListByData,
  getDevicesByCustomer,
  getMonitorGathers,
  getMonitorHistory,
  getDeviceData,
  getS3FileListByCustomer,
  downLoadFoldFileFromS3,
  getCsvContent,
  getProductLines,
  getDeviceCustomerById
} from "../../api/api";
import monitorDeviceDialog from "../../components/content/maintabber/MonitorDeviceDialog";
import monitorDialog from "../../components/content/monitor/MonitorDialog";
import monitorDeviceInfoDialog from "../../components/content/monitor/MonitorDeviceInfoDialog";
import monitorCcnTable from "../../components/content/monitor/MonitorCcnTable";
import monitorMaintainDialog from "../../components/content/monitor/MonitorMaintainDialog";
import monitorTripWarningDialog from "../../components/content/monitor/MonitorTripWarning";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { monitorMixin } from "../../mixins/monitorMixin";
import k1 from "../../assets/img/img_machine.png";
import k2 from "../../assets/img/img_machine.png";
export default {
  name: "index",
  components: {
    "monitor-device-dialog": monitorDeviceDialog,
    "monitor-dialog": monitorDialog,
    "monitor-deviceInfo-Dialog": monitorDeviceInfoDialog,
    "monitor-ccn-table": monitorCcnTable,
    "monitor-maintain-dialog": monitorMaintainDialog,
    "monitor-TripWarning-Dialog": monitorTripWarningDialog,
  },
  mixins: [monitorMixin],
  computed: {
    ...mapGetters({
      activeLang: "language",
    }),
    ...mapState({
      isCollapse: (state) => state.isCollapse,
    }),
  },

  async mounted() {
    await this.getProductLines();
    // await this.getCustOption();
    if (this.$route.params.customerId) {
      this.$set(this.formselect, "value3", [this.$route.params.customerId]);
    }
    await this.getCustomerRegionTree();
    await this.changeProductLine();
    await this.getDataList();
    await this.getGatherOption();
    
  },
  data() {
    return {
      projectType:"Back",
      isShowSize: true,
      companyTypeList: {
        直管: "desc.straightPipe",
        经销商: "desc.dealer",
        服务经销商: "desc.serviceDistributor",
        中间商: "desc.middleman",
        其他: "desc.other",
      },
      ReportDialog: false,
      ReportFormselect: {
        queryString: "",
      },
      ReportData: [],
      dialogClient: false,
      dialogMonitor: false,
      showEDiv: false,
      formselect: {},
      SNselect: {},
      clientList: [],
      deviceTable: [],
      deviceTableShow: [],

      customerId: "",
      //监控页面数据
      deviceOption: [],
      gatherOption: [],
      gatherOptionShow: [],
      monitorDataList: [],
      //空压机详细
      CustomerInfo: {},

      centerOptions: [],
      centerOptionsShow: [],
      custOptions: [],
      custOptionsShow: [],
      skipCount: 0,
      maxResultCount: 10,
      totalPage: 1,
      dialogTitle: "",
      ccnCodeList: [],
      deviceState: "",

      //辅助字段
      ccnGsn: "",
      infoDsn: "",
      //告警
      alarmList: [],
      dialogTripWarning: false,
      hisCustomer: {},
      customeId: "",

      ServiceTable: [
        { AssetsName: "1593290", serviceLog: "Null", serviceTime: "Null" },
        { AssetsName: "1595220", serviceLog: "Null", serviceTime: "需要维修" },
        {
          AssetsName: "1969309",
          serviceLog: "Null",
          serviceTime: "2022-04-06",
        },
      ],
      AlarmTable: [],
      PdfContent: {},
      Data: [],
      TimeData: [],
      RuntimeData: [],
      productLineArr:[],
      eightSpanArr:{
        'PacMU': ['kstate', 'kTime', 'loadTime', 'systemPre', 'dischargePre', 'stage1Vir', 'stage2Intemp'],
        'PacNotMU': ['kstate', 'kTime', 'loadTime', 'systemPre', 'stage1Pre', 'stage1Vir', 'stage1Temp'],
        'ding': ['kstate', 'kTime', 'loadTime', 'dp', 'sdt2', 'rp', 'mc'],
        'bian': ['kstate', 'kTime', 'vms', 'dp', 'sdt2', 'targetP', 'mc'],
        'BS5DH': ['kstate', 'kTime', 'vms', 'dp', 'sdt2', 'targetP', 'mc'],
        'SVT': ['kstate', 'kTime', 'vms', 'dp', 'sdt2', 'targetP', 'mc'],
        'BM200': ['kstate', 'kTime', 'vms', 'dp', 'sdt2', 'targetP', 'mc'],
      },
    };
  },

  methods: {
    async getProductLines(){
      let that=this;
      let res = await getProductLines();
      that.productLineArr = res.result;
      this.$set(this.formselect, "value1", "Other")
    },
    async getCustomerRegionTree() {
      let that = this;
      let res = await getCustomerRegionTree();
      let data = res.result;
      that.centerOptions = data;
    },
    async getCustOption() {
      let that = this;
      let res = await getAllCustomer();
      let data = res.result;
      that.custOptions = data;
      for (let index = 0; index < data.length; index++) {
        that.custOptions[index].customerName =
          data[index].customerCode +
          "_" +
          data[index].customerName +
          "_" +
          data[index].companyType +
          "_" +
          data[index].manageCpName;
      }
    },
    getGatherOption() {
      let that = this;
      getMonitorGathers().then((res) => {
        let data = res.result;
        that.gatherOption = data;
        that.gatherOptionShow = this.unique(data.filter((bbb) =>
          this.unitList.some((unit) => unit == bbb.unit)
        ));
      });
    },
    unique(arr) {//去重
      const res = new Map();
      return arr.filter((a) => !res.has(a.name) && res.set(a.name, 1));
    },
    getDataList() {
      let that = this;
      let data = {
        CustomerName: that.formselect.customerName,
        CustomerType: that.formselect.value1,
        CenterList: that.formselect.value2,
        Customer: that.formselect.value3,
        SkipCount: that.skipCount, //相当于页数-1
        MaxResultCount: that.maxResultCount, //相当于每页调数
      };
      getCustomerListByData(data).then((res) => {
        let data = res.result.items;
        that.clientList = data;
        that.totalPage = res.result.totalCount;
      });
    },
    getDeviceTable(select, custId) {
      let that = this;
      let data = {
        idList: [custId],
        dsn: select.value1,
        state: select.value4,
        Language: this.activeLang,
      };
      getDevicesByCustomer(data).then((res) => {
        let data = res.result;
        that.deviceTable = data;
        //应该添加一个不循环的方法
        that.getDeviceData();
      });
    },
    getMonitorHistory(value, value2, value3, value4, type, deviceOption) {
      let that = this;
      let data = {
        gsnList: value2,
        paraList: value.value2,
        startTime: value3,
        endTime: value4,
        dateTime: value.date,
        type: type,
        language: this.activeLang,
      };
      getMonitorHistory(data).then((res) => {
        let data = res.result;
        if (data.length === 0) {
          that.$message({
            showClose: true,
            message: "未找到监控数据",
            type: "error",
          });
          return false;
        }
        //先赋值dsn 再渲染图标
        that.monitorDataList = new Array();
        for (let index = 0; index < data.length; index++) {
          //.赋值无法监控
          data[index].dsn = deviceOption.find(
            (a) => a.gsn == data[index].gsn
          )?.dsn;
          
          //push赋值对象才能监控到变化
          that.monitorDataList.push(data[index]);
        }
        this.$nextTick(() => {
          setTimeout(() => {
            for (let index = 0; index < data.length; index++) {
              //.赋值无法监控
              data[index].dsn = deviceOption.find(
                (a) => a.gsn == data[index].gsn
              )?.dsn;
              //push赋值对象才能监控到变化
              that.initEcharts("Kchart_" + index, that.monitorDataList[index]);
            }
          }, 300);
        });
      });
    },
    //这是一个闭合循环 怎么在开始下一个循环时停止当前循环
    getDeviceData() {
      let that = this;

      if (!this.dialogClient) {
        return false;
      }

      let gsnList = new Array();
      for (let index = 0; index < that.deviceTable.length; index++) {
        gsnList.push(that.deviceTable[index].gsn);
      }
      let data = {
        gsnList: gsnList,
      };
      getDeviceData(data).then((res) => {
        let data = res.result;
        this.monitorHistoryData = data;
        this.deviceTableShow = new Array();
        for (let index = 0; index < that.deviceTable.length; index++) {
          var curData = data.find(
            (item) => item.gsn == that.deviceTable[index].gsn
          );
          let nameArrBS5DH = ["Package Discharge Pressure", "Running Time", "Loaded Time", "Airend Discharge Pressure", "Rated Pressure", "Airend Discharge Temperature", "Compression Ratio"];
          let nameArrBM200 = ["Package Status", "Blower Inlet Pressure", "Blower Inlet Temperature", "Package Discharge Pressure", "Main Motor Winding Temperature", "Current Flow", "Main Vsd Motor Speed"];
          let nameArrSVT = ["Inlet Pressure", "Airend Discharge Pressure", "Oil Injection Pressure", "Target Pressure", "Running Time", "Main Vsd Motor Current", "Main Vsd Motor Voltage"];
          let nArr = new Array();
          let indexName = this.isDingOrBian;
          if (this.isDingOrBian == "BS5DH") {
            nArr = nameArrBS5DH;
          } else if (this.isDingOrBian == "BM200") {
            nArr = nameArrBM200;
          } else if (this.isDingOrBian == "SVT") {
            nArr = nameArrSVT;
          }
          if (curData) {
            let kstateValue = curData.data.find(a => a.n == "Compressor Status Word" || a.n.replace(" ", "") == "PackageStatus");
            if (kstateValue && kstateValue.v2) {
              that.deviceTable[index].kstate = that.activeLang == "zh"? kstateValue.v2: that.$t("desc."+kstateValue.v2.trim())
            } else {
              that.deviceTable[index].kstate = that.$t("tips.NA");
            }
            //pac八块 一级排气压力
            let stage1PreValue = curData.data.find((a) => a.n.replace('  ',' ') == "Stage 1 Pressure");
            if (stage1PreValue && stage1PreValue.v) {
              that.deviceTable[index].stage1Pre = stage1PreValue.v + " " + stage1PreValue.unit;
            } else {
              that.deviceTable[index].stage1Pre = that.$t("tips.NA");
            }
            //一级振动
            let stage1VirValue = curData.data.find((a) => a.n.replace('  ',' ') == "Stage 1 Virbation" || a.n.replace('  ',' ') == "Stage 1 Vibration");
            if (stage1VirValue && stage1VirValue.v) {
              that.deviceTable[index].stage1Vir = stage1VirValue.v + " " + stage1VirValue.unit;
            } else {
              that.deviceTable[index].stage1Vir = that.$t("tips.NA");
            }
            //一级排气温度
            let stage1TempValue = curData.data.find((a) => a.n.replace('  ',' ') == "Stage 1 Temperature");
            if (stage1TempValue && stage1TempValue.v) {
              that.deviceTable[index].stage1Temp = stage1TempValue.v + " " + stage1TempValue.unit;
            } else {
              that.deviceTable[index].stage1Temp = that.$t("tips.NA");
            }
            //系统压力
            let systemPreValue = curData.data.find((a) => a.n == "System Pressure");
            if (systemPreValue && systemPreValue.v) {
              that.deviceTable[index].systemPre = systemPreValue.v + " " + systemPreValue.unit;
            } else {
              that.deviceTable[index].systemPre = that.$t("tips.NA");
            }
            //排气压力
            let dischargePreValue = curData.data.find((a) => a.n == "Discharge Pressure");
            if (dischargePreValue && dischargePreValue.v) {
              that.deviceTable[index].dischargePre = dischargePreValue.v + " " + dischargePreValue.unit;
            } else {
              that.deviceTable[index].dischargePre = that.$t("tips.NA");
            }
            //二级进气温度
            let stage2IntempValue = curData.data.find((a) => a.n == "Stage 2 Inlet Temp");
            if (stage2IntempValue && stage2IntempValue.v) {
              that.deviceTable[index].stage2Intemp = stage2IntempValue.v + " " + stage2IntempValue.unit;
            } else {
              that.deviceTable[index].stage2Intemp = that.$t("tips.NA");
            }
    
            let targetPValue = curData.data.find((a) => a.n == "Target Pressure");
            if (targetPValue && targetPValue.v) {
              that.deviceTable[index].targetP = targetPValue.v + " " + targetPValue.unit;
            } else {
              that.deviceTable[index].targetP = that.$t("tips.NA");
            }
    
            let vmsValue = curData.data.find((a) => a.n == "Vsd Motor Speed");
            if (vmsValue && vmsValue.v) {
              that.deviceTable[index].vms = vmsValue.v + " " + vmsValue.unit;
            } else {
              that.deviceTable[index].vms = that.$t("tips.NA");
            }
    
            let ktimeValue = curData.data.find((a) => a.z == "运行时间");
            if (ktimeValue && ktimeValue.v) {
              if (that.IsShowSensitive == true) {
                that.deviceTable[index].kTime = ktimeValue.v;
              } else {
                that.deviceTable[index].kTime = ktimeValue.v + that.$t("desc.simpleHours");
              }
            } else {
              that.deviceTable[index].kTime = that.$t("tips.NA");
            }
    
            let dpvalue = curData.data.find(
              (a) => a.n == "Compressor Discharge Pressure"
            );
            if (dpvalue && dpvalue.v) {
              that.deviceTable[index].dp = dpvalue.v + " " + dpvalue.unit;
            } else {
              that.deviceTable[index].dp = that.$t("tips.NA");
            }
    
            var fsdtValue = curData.data.find(
              (a) => a.n == "Final Stage Discharge Temperature"
            );
            var twosdtValue = curData.data.find(
              (a) => a.n == "2nd Stage Discharge Temperature"
            );
            if (fsdtValue && fsdtValue.v > "0.0") {
              that.deviceTable[index].sdt2 = fsdtValue.v
                ? fsdtValue.v + " " + fsdtValue.unit
                : that.$t("tips.NA");
            } else if (twosdtValue) {
              that.deviceTable[index].sdt2 = twosdtValue.v
                ? twosdtValue.v + " " + twosdtValue.unit
                : that.$t("tips.NA");
            } else if (fsdtValue && fsdtValue.v == "0.0") {
              that.deviceTable[index].sdt2 = fsdtValue.v
                ? fsdtValue.v + " " + fsdtValue.unit
                : that.$t("tips.NA");
            } else {
              that.deviceTable[index].sdt2 = that.$t("tips.NA");
            }
    
            var rpValue = curData.data.find((a) => a.n == "Rated Pressure");
            if (rpValue && rpValue.v) {
              that.deviceTable[index].rp = rpValue.v + " " + rpValue.unit;
            } else {
              that.deviceTable[index].rp = that.$t("tips.NA");
            }
    
            var mcValue = curData.data.find((a) => a.n == "Driver Motor Current");
            let mmcpA = curData.data.find(
              (a) => a.n == "Main Motor Current Phase A"
            );
            if (mcValue && mcValue.v > "0.0") {
              that.deviceTable[index].mc = mcValue.v
                ? mcValue.v + " " + mcValue.unit
                : that.$t("tips.NA");
            } else if (mmcpA) {
              that.deviceTable[index].mc = mmcpA.v ? mmcpA.v + " " + mmcpA.unit : that.$t("tips.NA");
            } else if (mcValue && mcValue.v == "0.0") {
              that.deviceTable[index].mc = mcValue.v
                ? mcValue.v + " " + mcValue.unit
                : that.$t("tips.NA");
            } else {
              that.deviceTable[index].mc = that.$t("tips.NA");
            }
    
            var loadTimeValue = curData.data.find((a) => a.z == "加载时间" || a.z == "全加载");
            if (loadTimeValue && loadTimeValue.v) {
              if (that.IsShowSensitive == true) {
                that.deviceTable[index].loadTime = loadTimeValue.v;
              } else {
                that.deviceTable[index].loadTime = loadTimeValue.v + that.$t("desc.simpleHours");
              }
            } else {
              that.deviceTable[index].loadTime = that.$t("tips.NA");
            }
            //#region BV八块数据
            that.eightSpanArr[indexName] = new Array();
            for (let index = 0; index < nArr.length; index++) {
              const element = nArr[index];
              let BS5DHValue = curData.data.find((a) => a.n == element);
              if (BS5DHValue && BS5DHValue.v) {
                if (element == "Running Time" && that.IsShowSensitive == true) {
                  that.deviceTable[index][indexName+index] = BS5DHValue.v
                } else if (element == "Running Time" && that.IsShowSensitive == false) {
                  that.deviceTable[index][indexName+index] = BS5DHValue.v + that.$t("desc.simpleHours");
                } else {
                  that.deviceTable[index][indexName+index] = BS5DHValue.v + " " + (BS5DHValue.unit? BS5DHValue.unit: "");
                }
              } else {
                that.deviceTable[index][indexName+index] = that.$t("tips.NA");
              }
              that.eightSpanArr[indexName].push(indexName+index);
              let translate = that.$t("eightSpan." + indexName + index);
            }
            //#endregion
    
          } else {
            that.deviceTable[index].kstate = that.$t("tips.NA");
            that.deviceTable[index].kstateNum = that.$t("tips.NA");
            that.deviceTable[index].targetP = that.$t("tips.NA");
            that.deviceTable[index].vms = that.$t("tips.NA");
            that.deviceTable[index].kTime = that.$t("tips.NA");
            that.deviceTable[index].dp = that.$t("tips.NA");
            that.deviceTable[index].dt = that.$t("tips.NA");
            that.deviceTable[index].fsdt = that.$t("tips.NA");
            that.deviceTable[index].sdt2 = that.$t("tips.NA");
            that.deviceTable[index].rp = that.$t("tips.NA");
            that.deviceTable[index].mc = that.$t("tips.NA");
            that.deviceTable[index].loadTime = that.$t("tips.NA");

            that.deviceTable[index].stage1Pre = that.$t("tips.NA");
            that.deviceTable[index].stage1Vir = that.$t("tips.NA");
            that.deviceTable[index].stage1Temp = that.$t("tips.NA");
            that.deviceTable[index].systemPre = that.$t("tips.NA");
            that.deviceTable[index].dischargePre = that.$t("tips.NA");
            that.deviceTable[index].stage2Intemp = that.$t("tips.NA");

            //BV八块数据
            for (let index = 0; index < nArr.length; index++) {
              const element = nArr[index];
              that.deviceTable[index][indexName + index]  = that.$t("tips.NA");
            }
            // if (that.DeviceInfo.unLoadTime) that.DeviceInfo.unLoadTime = "";
          }
          if (that.deviceState) {
            if (
              that.deviceTable[index].kstate &&
              that.deviceTable[index].kstate.indexOf(that.deviceState) != -1
            ) {
              that.deviceTableShow.push(that.deviceTable[index]);
            } else {
            }
          } else {
            that.deviceTableShow.push(that.deviceTable[index]);
          }
        }
        //如果打开了ccn列表就试试更新数据
        // if (this.dialogDeviceCCN) {
        //   this.getCcnTable(this.ccnGsn);
        // }
        if (that.dialogDevice) {
          that.DeviceInfo = JSON.parse(
            JSON.stringify(
              that.deviceTableShow.find((a) => a.dsn == that.infoDsn)
            )
          );
          that.DeviceInfoShow = JSON.parse(JSON.stringify(that.DeviceInfo));
        }
        this.stopDeviceData = setTimeout(function () {
          that.getDeviceData();
        }, 70 * 1000);
      });
    },
    async openClient(visible, item) {
      this.dialogClient = visible;
      if (visible) {
        this.dialogTitle = item.customerName;
        this.getDeviceTable("", item.id);
        let res = await getDeviceCustomerById({ id: item.id });
        this.CustomerInfo = res.result;
        this.customerId = item.id;
      } else {
        this.CustomerInfo = {};
        this.customerId = "";
        this.deviceTableShow = [];
        if (this.stopDeviceData) {
          clearTimeout(this.stopDeviceData);
        }
      }
    },

    async openMonitor(visible, item) {
      this.dialogMonitor = visible;
      if (visible) {
        this.hisCustomer = item;
        this.dialogTitle = item.customerName;
        // this.$nextTick(() => {
        //   this.$refs.monitorRef.showEcharts();
        // });
        // this.$refs.monitorRef.showEcharts();
      } else {
        this.monitorDataList = [];
      }
    },
    handleSizeChange(val) {
      this.maxResultCount = val;
      this.getDataList();
    },
    handleCurrentChange(val) {
      this.skipCount = val;
      this.getDataList();
    },
    resetKeyword() {
      this.formselect = {
        value1: "Other",
      };
    },
    changeCState(value) {
      this.deviceState = value;
    },

    initEcharts(id, echartData) {
      var Kchart1 = this.$echarts.init(document.getElementById(id));

      var Linecolor = ["#4D9DC6", "#95DBD3", "#A5E893", "#FFE8AA", "#4179A2"];
      var Linecolor2 = [
        "rgba(0,117,155,0.05)",
        "rgba(0,182,125,0.05)",
        "rgba(3,81,139,0.05)",
        "rgba(255,222,118,0.05)",
        "rgba(54,144,137,0.05)",
      ];
      var seriesList = [];
      let codeListShow = new Array();
      for (let index = 0; index < echartData.codeList.length; index++) {
        let curCode = "";
        if (this.activeLang == "zh") {
          curCode = this.gatherOption.find(
            (item) => item.name == echartData.codeList[index]
          )?.nameZH;
        } else {
          curCode = this.gatherOption.find(
            (item) => item.name == echartData.codeList[index]
          )?.name;
        }
        codeListShow.push(curCode);
      }

      for (var i = 0; i < echartData.chartDataList.length; i++) {
        var temp = {
          name: echartData.codeList[i],
          type: "line",
          smooth: true, //是否平滑
          showSymbol: false,
          symbolSize: 4,
          lineStyle: {
            normal: {
              color: Linecolor[i],
              width: 2,
            },
          },
          itemStyle: {
            borderColor: Linecolor[i],
            color: Linecolor[i],
          },
          areaStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: Linecolor[i] },
                { offset: 1, color: Linecolor2[i] },
              ]),
            },
          },
          data: echartData.chartDataList.find(
            (item) => item.code === echartData.codeList[i]
          )?.dataList,
        };
        seriesList.push(temp);
      }

      var optionK = {
        legend: {
          data: codeListShow,
          textStyle: {
            color: "#999",
            align: "left",
          },
          left: 10,
          top: 10,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] / 2 - 20, point[1] - 150];
          },
          backgroundColor: "#141518", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#828393",
            fontSize: 10,
            fontFamily: "Arial",
          },
          formatter: (param) => {
            let str = "<div style='margin: 0px 0 0;line-height:1;'>"+
            "<div style='margin: 0px 0 0;line-height:1;'>"+
            "<div style='font-size:10px;color:#828393;font-weight:400;line-height:1;'>" + param[0].axisValue + "</div>" +
            "<div style='margin: 0px 0 0;line-height:1;'>";
            for (let index = 0; index < param.length; index++) {
              let curCode = "";
              if (this.activeLang == "zh") {
                curCode = this.gatherOption.find(
                  (item) => item.name == echartData.codeList[index]
                )?.nameZH;
              } else {
                curCode = this.gatherOption.find(
                  (item) => item.name == echartData.codeList[index]
                )?.name;
              }
              const element = param[index];
              const unit = echartData.chartDataList.find(
                (item) => item.code === element.seriesName
              )?.unit ?? "";
              str += "<div style='margin: 10px 0 0;line-height:1;'>" + 
              "<div style='margin: 0px 0 0;line-height:1;'>"+
              element.marker + 
              "<span style = 'font-size:10px;color:#828393;font-weight:400;margin-left:2px'>" + curCode + "</span>" + 
              "<span style='float:right;margin-left:20px;font-size:10px;color:#828393;font-weight:900'>"+ (element.value+"").parseNum() +"&nbsp" + unit +"<span>" +
              "<div style='clear:both'></div></div> <div style='clear:both'></div></div>"
            }
            str += "<div style='clear:both'></div></div> <div style='clear:both'></div></div> <div style='clear:both'></div></div>"
            return str;
          }
        },
        grid: {
          top: 60,
          left: 40,
          right: 40,
          bottom: 80,
        },
        dataZoom: [
          {
            show: true,
            height: 26,
            xAxisIndex: [0],
            bottom: 20,
            start: 80,
            end: 100,
            textStyle: {
              color: "#A7B7CC",
            },
          },
          {
            type: "inside",
            show: true,
            height: 15,
            start: 1,
            end: 35,
          },
        ],
        xAxis: [
          {
            type: "category",
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: true,
              color: "#828393",
              textStyle: {
                fontSize: 10,
                fontFamily: "Arial",
              },
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },

            boundaryGap: false,
            data: echartData.dateTimeList,
          },
        ],

        yAxis: {
          type: "value",
          splitNumber: 3,
          splitLine: {
            show: true,
            lineStyle: {
              color: "#3A3D46",
            },
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 10,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        series: seriesList,
      };

      Kchart1.setOption(optionK);

      window.addEventListener("resize", () => {
        Kchart1.resize();
      });
    },
    openTripWarningDialog(visible) {
      this.dialogTripWarning = visible;
    },

    async getReportDatas(foldName) {
      let that = this;
      // if (type == "search") {
      //   that.pagination.current = 1;
      // }
      // let skipcount = (that.pagination.current - 1) * that.pagination.pageSize;
      let postData = {
        FileName: "",
        FoldName: foldName,
        CustomerId: that.customeId,
        Times: that.ReportFormselect.time,
        // SkipCount: skipcount,
        // MaxResultCount: that.pagination.pageSize,
      };
      let res = await getS3FileListByCustomer(postData);
      let data = res.result;
      // that.pagination.totalPage = res.result.totalCount;
      return data;
    },
    async getReportList(type) {
      let that = this;
      that.ReportData = new Array();
      if (
        !that.ReportFormselect.queryString ||
        that.ReportFormselect.queryString === "all"
      ) {
        // let report3 = await that.getReportDatas("report3");
        // that.ReportData.push(...report3);
        // let report4 = await that.getReportDatas("report4");
        // that.ReportData.push(...report4);
        // let report5 = await that.getReportDatas("report5");
        // that.ReportData.push(...report5);
      } else {
        let report = await that.getReportDatas(
          that.ReportFormselect.queryString
        );
        that.ReportData.push(...report);
      }

      that.ReportData = that.ReportData.sort((a, b) => {
        a.lastModified === b.lastModified
          ? 0
          : a.lastModified < b.lastModified
          ? 1
          : -1;
      });
      if (this.ReportFormselect.queryString == "report5") {
        that.ReportData.forEach((item) => {
          item.name = item.name.replace(".xlsx", ".pdf");
          item.fileType = "pdf";
        });
        this.isShowSize = false;
      } else {
        this.isShowSize = true;
      }
    },
    async downLoadRunTImeFileFromS3(row) {
      let that = this;
      if (row.keyName.indexOf("report5") != -1) {
        await that.downLoadReport5(row);
      } else {
        await that.downLoadReport3or4(row);
      }
    },
    async downLoadReport5(row) {
      let that = this;
      await that.getPdfData(row);
      await that.loadChart();
      setTimeout(() => {
        that.getPdf(row.name.split(".")[0]);
      }, 3000);
    },
    async getPdfData(row) {
      let that = this;
      let res = await getCsvContent(row.keyName);
      that.PdfContent = res.result;
      that.AlarmTable = that.PdfContent.alarmList;
      that.ServiceTable = that.PdfContent.maintainList;
      that.Data = that.PdfContent.loadChart.map((x) => x.value);
      that.TimeData = that.PdfContent.loadChart.map((x) => x.date);
      that.RuntimeData = that.PdfContent.runningChart.map((x) => x.value);
    },
    async loadChart() {
      let that = this;
      this.$nextTick(() => {
        that.initPDFLine(
          "Line1",
          that.$t("desc.loadingRate"),
          "%",
          that.TimeData,
          that.Data,
          100
        );
        that.initPDFLine(
          "Line2",
          that.$t("desc.DailyRunningTime"),
          "h",
          that.TimeData,
          that.RuntimeData,
          Math.max(...that.RuntimeData)
        );
      });
    },
    async downLoadReport3or4(row) {
      let that = this;
      let res = await downLoadFoldFileFromS3(row.keyName);
      // const blob = new Blob([res]);//处理文档流
      const fileName = row.keyName;
      const elink = document.createElement("a");
      elink.download = fileName;
      elink.style.display = "none";
      // elink.target = "_blank"
      elink.href = res.result;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
    resetReport() {
      this.ReportFormselect = {
        queryString: "",
      };
    },
    async openReportDialog(row) {
      let that = this;
      that.ReportDialog = true;
      this.customeId = row.id;
      // await that.getReportList();
    },
    async closeReportDialog() {
      let that = this;
      that.ReportDialog = false;
      that.ReportData = new Array();
      that.resetReport();
    },

    initPDFLine(id, name, unit, TimeData, Data, max) {
      var ActivationLine = this.$echarts.init(document.getElementById(id));

      var optionActivationLine = {
        title: {
          text: name,
          top: 10,
          left: -5,
          textStyle: {
            fontSize: 14,
            color: "#555",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
          position: function (point, params, dom, rect, size) {
            // 固定在顶部
            return [point[0] / 2 - 50, point[1] - 100];
          },
          backgroundColor: "#E3E8EA", // 提示背景颜色，默认为透明度为0.7的黑色
          borderColor: "rgba(0,0,0,0)",
          textStyle: {
            color: "#434346",
            fontSize: 12,
            fontFamily: "Arial",
          },
        },
        grid: {
          top: 40,
          left: 35,
          right: 5,
          bottom: 20,
        },
        xAxis: {
          type: "category",
          splitLine: {
            show: false,
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 12,
              fontFamily: "Arial",
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          // boundaryGap: false,
          data: TimeData,
        },
        yAxis: {
          type: "value",
          splitNumber: 5,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#D5D5D5",
            },
          },
          axisLabel: {
            show: true,
            color: "#828393",
            textStyle: {
              fontSize: 12,
              fontFamily: "Arial",
            },
            formatter: function (value, index) {
              return value + unit;
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          max: max,
          min: 0,
        },
        series: [
          {
            name: name,
            type: "line",
            cursor: "default",
            // smooth: true, //是否平滑
            showAllSymbol: true,
            symbol: "circle",
            symbolSize: 7,
            lineStyle: {
              normal: {
                color: "#035062",
              },
            },
            itemStyle: {
              color: "#00759B",
              borderColor: "rgba(255,255,255,1)",
              borderWidth: 1,
            },
            emphasis: {
              cursor: "default",
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "rgba(255,255,255,0.5)" },
                  { offset: 0.9, color: "rgba(255,255,255,0)" },
                  { offset: 1, color: "rgba(255,255,255,0)" },
                ]),
              },
            },
            data: Data,
          },
        ],
      };
      ActivationLine.setOption(optionActivationLine);

      window.addEventListener("resize", () => {
        ActivationLine.resize();
      });
    },

    //PAC
    changeProductLine() {
      let that = this;
      if (that.formselect.value1 === "PAC") {
        that.centerOptionsShow = that.centerOptions.filter(
          (x) => x.centerType === that.formselect.value1
        );
        that.custOptionsShow = that.custOptions.filter(
          (x) => x.customerType === that.formselect.value1
        );
      } else {
        that.centerOptionsShow = that.centerOptions.filter(
          (x) => x.centerType !== "PAC"
        );
        that.custOptionsShow = that.custOptions.filter(
          (x) => x.customerType !== "PAC"
        );
      }
    },
  },
  created() {
    var _self = this;
  },
};
</script>


